<script lang="ts">
  import { storyblokEditable } from '$lib/actions/storyblok-editable';
  import { cn } from '$lib/utils';
  import type { TitleSectionStoryblok } from '$types/bloks';
  import CenteredTitle from './marketing-sub-blocks/centered-title.svelte';
  import Collections from './marketing-sub-blocks/collections.svelte';
  import CustomerReviews from './marketing-sub-blocks/customer-reviews.svelte';
  import ImageWithCta from './marketing-sub-blocks/image-with-cta.svelte';
  import Images from './marketing-sub-blocks/images.svelte';
  import ProductsGrid from './marketing-sub-blocks/products-grid.svelte';
  import ProductsWithCta from './marketing-sub-blocks/products-with-cta.svelte';
  import ShopTheLookCards from './marketing-sub-blocks/shop-the-look-cards.svelte';
  import Video from './marketing-sub-blocks/video.svelte';

  export let block: TitleSectionStoryblok;

  $: ignoreContainer =
    block.content.some(
      (b) => b.component === 'products-with-cta' && b.variant === 'desktop-carousel'
    ) || block.content.some((b) => b.component === 'shop-the-look-cards');
</script>

<section use:storyblokEditable={block} class="px-2 lg:px-8 !py-0">
  <div class="container mx-auto">
    {#if block.title?.[0]}
      <CenteredTitle block={block.title?.[0]} />
    {/if}
  </div>

  <div class={cn(ignoreContainer ? '' : 'container mx-auto')}>
    {#each block.content as content}
      {#if content.component === 'images'}
        <Images {content} />
      {:else if content.component === 'video'}
        <Video {content} />
      {:else if content.component === 'collections'}
        <Collections {content} />
      {:else if content.component === 'products-with-cta'}
        <ProductsWithCta {content} />
      {:else if content.component === 'products-grid'}
        <ProductsGrid {content} />
      {:else if content.component === 'shop-the-look-cards'}
        <ShopTheLookCards {content} />
      {:else if content.component === 'image-with-cta'}
        <ImageWithCta {content} />
      {:else if content.component === 'customer-reviews'}
        <CustomerReviews {content} />
      {/if}
    {/each}
  </div>
</section>
